import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

const mutation = graphql`
    mutation updateEventMutation($input: updateHyeventInput!){
        updateHyevent(input:$input) {
          clientMutationId
          hyevent{
            address
            additionalGuestAllowed
            approvedAt
            approverName
            cancelReason
            cancelledAt
            confirmPageHtml
            cancelRsvpPageHtml
            waitlistedPageHtml
            removeFromWaitlistPageHtml
            confirmSmsBody
            createdAt
            ctaText
            disapproveReason
            endAt
            flyerHtml
            id
            campaignTested
            image{
              createdAt
              dimension
              fileSize
              fileType
              fileUrl
              id
              name
              thumbnailUrl
            }
            document{
              createdAt
              dimension
              fileSize
              fileType
              fileUrl
              id
              name
              thumbnailUrl
            }
            inviteScheduledAt
            invitedGroups
            landingPageHtml
            maxAdditionalGuests
            maxNoOfGuests
            message
            messageTitle
            placeName
            propertyId
            publishAt
            rsvpedCount
            startAt
            status
            title
            updatedAt
            eventType
            zoomLink
            meetingId
            passcode
            smsEnabled
            displayTime
            leadFields
            rsvpFormHeader
            emailList
            recurringEventType
            repeatType
            recurrenceType
            recurrenceEndDate
            recurringDaysList
          }
        }
    }
`;

function commit(environment, input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      onCompleted: res,
      onError: rej
    })
  });
}

export default commit;